import { onBeforeUnmount, ref } from 'vue'
import {
  AUTH_AI_PREVIEW_PINNED_STEP_INDEX,
  AUTH_AI_PREVIEW_STEP_INTERVAL_MS,
  AUTH_AI_PREVIEW_STEPS,
} from '@/constants/AUTH_AI_PREVIEW'

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'

export const useAuthAiPreview = () => {
  const prefersReducedMotion = window.matchMedia(REDUCED_MOTION_QUERY).matches

  const activeIndex = ref(prefersReducedMotion ? AUTH_AI_PREVIEW_PINNED_STEP_INDEX : 0)

  let stepTimer: ReturnType<typeof setInterval> | null = null

  const stop = () => {
    if (stepTimer) {
      clearInterval(stepTimer)
      stepTimer = null
    }
  }

  // The run plays once. The tick after the last step leaves no active card
  // behind, so the list settles with every step completed.
  const goToNextStep = () => {
    activeIndex.value += 1

    if (activeIndex.value >= AUTH_AI_PREVIEW_STEPS.length) {
      stop()
    }
  }

  const start = () => {
    if (prefersReducedMotion || stepTimer) {
      return
    }

    stepTimer = setInterval(goToNextStep, AUTH_AI_PREVIEW_STEP_INTERVAL_MS)
  }

  onBeforeUnmount(stop)

  return {
    activeIndex,
    start,
  }
}
